import {Dispatch} from 'react';

import {PredicateOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {ClientRuleCondition} from '../../rules/ruleConditionModel';
import {ConditionAction, ConditionsActionTypesEnum} from './conditionsActions';

/*
 * Types.
 */

export interface ConditionsStateActions {
  onAddCondition: (indexAND: number, condition: ClientRuleCondition) => void;
  onUpdateCondition: (
    indexAND: number,
    predicate: PredicateOf<ClientRuleCondition>,
    update: (condition: ClientRuleCondition) => ClientRuleCondition,
  ) => void;
  onDeleteCondition: (indexAND: number, predicate: PredicateOf<ClientRuleCondition>) => void;
}

/*
 * Hook.
 */

export function useConditionsState(dispatch: Dispatch<ConditionAction>): ConditionsStateActions {
  const onAddCondition = (indexAND: number, condition: ClientRuleCondition) => {
    dispatch({type: ConditionsActionTypesEnum.ADD_CONDITION, indexAND, condition});
  };

  const onUpdateCondition = (
    indexAND: number,
    predicate: PredicateOf<ClientRuleCondition>,
    update: (cond: ClientRuleCondition) => ClientRuleCondition,
  ) => {
    dispatch({type: ConditionsActionTypesEnum.UPDATE_CONDITION, indexAND, predicate, update});
  };

  const onDeleteCondition = (indexAND: number, predicate: PredicateOf<ClientRuleCondition>) => {
    dispatch({type: ConditionsActionTypesEnum.DELETE_CONDITION, indexAND, predicate});
  };

  return {
    onAddCondition,
    onUpdateCondition,
    onDeleteCondition,
  };
}
